import Repository from '../axios'
import {defaultPagination} from "../constants/config";

const resource_stock = "/admin/inventory/stock";
export default {
  getRawMaterialStockAdjustLog(id, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`${resource_stock}/raw_material_stock/${id}/logs?paginate=${pagination}&page=${pageNumber}`)
  },
  getSundryItemStockAdjustLog(id, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`/admin/log/staff/inventory/sundry-inventory-change/${id}?paginate=${pagination}&page=${pageNumber}`)
  },
  getFinishedProductStockAdjustLog(id, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`${resource_stock}/product_stock/${id}/logs?paginate=${pagination}&page=${pageNumber}`)
  },

  getFormulationStockInventoryLog(id, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`/admin/log/staff/inventory/formulation-inventory-change/${id}?paginate=${pagination}&page=${pageNumber}`)
  },
  getStaffFormulationLogs(id, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`/admin/log/staff/formulation/${id}?paginate=${pagination}&page=${pageNumber}&per_page=${pagination}`)
  },
  getRawMaterialStockInventoryLog(id, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`/admin/log/staff/inventory/raw-material-inventory-change/${id}?paginate=${pagination}&page=${pageNumber}`)
  },
  getCurrencyAdjustLog(currency_id, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`/admin/log/others/currency/${currency_id}?paginate=${pagination}&page=${pageNumber}`)
  },
  downloadActivityLogReport(type, inventory_id, filters){
    return Repository.get(`/admin/export/log/staff/inventory/${type}/${inventory_id}?${filters}`,
     {responseType:'blob'})
  },
  downloadStockChangeLogReport(type, filters){
    return Repository.get(`/admin/export/log/staff/inventory/${type}?${filters}`,
     {responseType:'blob'})
  },
  getSalesOrderStatusLog(id, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`/admin/customer/product_status_log/${id}?paginate=${pagination}&page=${pageNumber}`)
  },
  viewSalesOrderInvoiceLogs(id, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`/admin/log/customer/product_order/invoice/${id}?paginate=${pagination}&page=${pageNumber}`)
  },
  viewSalesOrderLogs(id, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`/admin/log/customer/product_order/${id}?paginate=${pagination}&page=${pageNumber}`)
  },
  getCustomerLogs(id, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`/admin/log/customer/${id}?paginate=${pagination}&page=${pageNumber}`)
  },
  getDepartmentLogs(id, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`/admin/log/staff/department/${id}?paginate=${pagination}&page=${pageNumber}`)
  }
};
